<template>
  <div class="teaching-sign-table"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="sign-table-header">
      <el-form size="mini" label-width="86px">
        <el-form-item label="选择学期">
          <el-select v-model="semesterId"
                     size="mini"
                     filterable
                     placeholder="请选择学期"
                     @change="handleSemesterChange">
            <el-option v-for="semester in semesterList"
                       :key="semester.id"
                       :label="semester.name"
                       :value="semester.id"/>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="sign-table-content">
      <keep-alive>
        <TemplateDataGrid v-if="showGrid"
                          ref="grid"
                          :key="gridKey"
                          gridId="scheduleDetailsSign"
                          v-bind="gridParams"></TemplateDataGrid>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../../../../../templates/TemplateDataGrid'

export default {
  name: 'ScheduleDetailsSignClass',
  components: {
    TemplateDataGrid
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      // 学期相关
      semesterList: [],
      semesterId: '',
      // 控制表格显示
      showGrid: false,
      // 用于强制刷新grid
      gridKey: 0
    }
  },
  computed: {
    gridParams () {
      return {
        semesterId: this.semesterId,
        classId: this.rowData.id
      }
    }
  },
  methods: {
    // 加载学期数据
    loadSemesters () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/query/scheduleDetailsSign/querySemesters',
        method: 'post',
        data: this.$qs.stringify({
          classId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          this.semesterList = response.data['semesters'] || []
          if (this.semesterList.length) {
            this.semesterId = this.semesterList[0].id
            this.handleQuery()
          }
        }
      }).catch(() => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    // 学期变更后触发查询
    handleSemesterChange () {
      this.handleQuery()
    },
    // 提交查询
    handleQuery () {
      if (!this.semesterId) {
        this.showGrid = false
        return
      }
      // 刷新gridKey强制重新渲染TemplateDataGrid组件
      this.gridKey = Date.now()
      this.showGrid = true
    },
    // 初始化数据
    initData () {
      this.loadSemesters()
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style lang="scss">
  .teaching-sign-table {
    height: 100%;
    display: flex;
    flex-direction: column;
    .sign-table-header {
      padding: 15px;
      background-color: #fff;
      .el-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .el-form-item {
          margin-bottom: 0;
          margin-right: 20px;
          .el-select {
            width: 180px;
          }
        }
      }
    }
    .sign-table-content {
      flex: 1;
      overflow: hidden;
    }
  }
</style>
